<svg #fillLevelChart></svg>
